import { useContext, useState } from 'react'
import { useTranslation } from "react-i18next";

import { AppState } from 'App';
import { Loading } from 'components/misc/Icons'

import SidebarButton from 'components/ui/sidebar/SidebarButton'
import ModalAddPost from 'components/modals/ModalAddPost'
import ButtonSkeleton from 'components/skeletons/ButtonSkeleton'
import ButtonSkeletonDark from 'components/skeletons/ButtonSkeletonDark'
import { ChevronLeft, Heart } from 'components/misc/Icons'


const Sidebar = ({tags, icons, latitude, longitude, tagCounts}) => {

    const [appState, setAppState] = useContext(AppState)
    const [modalAddPostOpen, setModalAddPostOpen] = useState(false)
    const {t, i18n} = useTranslation('common');

    return (
        <div className="flex flex-row items-center flex-shrink-0 h-12 lg:flex-col lg:h-screen lg:items-start bg-itemlight dark:bg-bgdark lg:bg-bglight dark:lg:bg-none">

            <button
                onClick={() => setModalAddPostOpen(true)}
                className="flex-row items-center flex-shrink-0 hidden h-10 transition-colors duration-200 border rounded-lg lg:flex w-52 bg-itemlight dark:bg-itemdark hover:border border-borderlight focus:bg-bgitemlight focus:border focus:border-borderlight focus:outline-none dark:border-borderdark dark:text-textdark text-textlight hover:text-textlightfeature hover:border-borderlighthover" id="second"
            >
                {appState.loadingContext ?
                    <span className="mr-4 font-light tracking-tight"><span className="px-4">➕</span>Loading...</span>
                :
                    <span className="mr-4 font-light tracking-tight"><span className="px-4">➕</span>{t('newPostButton')}</span>
                }

                {appState.loadingContext & appState.tagContext===null ? <Loading width={4} height={4} stroke={3} /> : null}
            </button>

            <button
                onClick={() => setAppState(prevState => ({...prevState,favouriteContext:true}))}
                className="flex-row items-center flex-shrink-0 hidden h-10 transition-colors duration-200 border rounded-lg lg:flex lg:mt-4 w-52 bg-itemlight dark:bg-itemdark hover:border border-borderlight focus:bg-bgitemlight focus:border focus:border-borderlight focus:outline-none dark:border-borderdark dark:text-textdark text-textlight hover:text-textlightfeature hover:border-borderlighthover">
                <span className="flex items-center mr-4 font-light tracking-tight">
                    <span className="px-3">
                        <Heart width="6" height="6" stroke="2"/>
                    </span>
                    Favourites
                </span>
            </button>

            <h2 className="hidden lg:mt-8 lg:mb-6 lg:block dark:text-textdark text-textlight">{t('SB_topicHeading')}</h2>

            <div className="flex flex-row space-x-2 lg:flex-col lg:space-y-3 lg:space-x-0" id="fifth">


                { appState.loadingContext ? (
                    <>
                    <div className="block dark:hidden">
                        <ButtonSkeleton/>
                    </div>
                    <div className="hidden dark:block">
                        <ButtonSkeletonDark/>
                    </div>
                    </>
                ) : tags && tags.sort().map(tag => (
                    <SidebarButton key={tag} tag={tag} icons={icons} tagCounts={tagCounts}/>
                ))}

                {appState.tagContext!==null || appState.dateContext!==null || appState.favouriteContext!==null || appState.latitude!==null ? (
                    <button
                        onClick={() => setAppState(prevState => ({...prevState,tagContext:null,dateContext:null,favouriteContext:null,latitude:null,longitude:null}))}
                        className="flex flex-row items-center h-10 border border-transparent rounded-lg w-52 hover:bg-itemlight hover:border hover:border-borderlight focus:bg-itemlight focus:border focus:border-borderlight focus:outline-none dark:hover:bg-itemdark dark:hover:border-borderdark dark:focus:border-borderdark dark:focus:bg-itemdark"
                    >
                        <span className="flex items-center mr-4 font-light tracking-tight dark:text-textdark text-textlight">
                            <span className="px-2 text-2xl">
                                <ChevronLeft width="5" height="5" stroke="1"/>
                            </span>{t('SB_allTopics')}
                        </span>
                        {appState.loadingContext & appState.tagContext===null ? <Loading width={4} height={4} stroke={3} /> : null}
                    </button>
                )
                : null
                }

            </div>
            <ModalAddPost open={modalAddPostOpen} onClose={() => setModalAddPostOpen(false)} latitude={latitude} longitude={longitude}/>
        </div>
    )
}

export default Sidebar
